/**
 * KRS consent bridge — Shopify Customer Privacy API ↔ Google Consent Mode + gated GTM.
 * Does not call setTrackingConsent automatically; only reacts to Shopify banner / GPC / prefs.
 */
(function () {
  'use strict';

  var GTM_LOADED = false;
  var GTM_TRACKING_LOADED = false;
  var listenersBound = false;

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = window.gtag || gtag;

  // Defaults denied before any tags
  gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
    functionality_storage: 'granted',
    security_storage: 'granted',
    wait_for_update: 500,
  });

  function getConfig() {
    return window.krsConsentConfig || {};
  }

  function readAllowed(cp) {
    var analytics = false;
    var marketing = false;
    var saleOfData = false;
    var preferences = false;

    try {
      if (typeof cp.analyticsProcessingAllowed === 'function') {
        analytics = !!cp.analyticsProcessingAllowed();
      }
      if (typeof cp.marketingAllowed === 'function') {
        marketing = !!cp.marketingAllowed();
      }
      if (typeof cp.saleOfDataAllowed === 'function') {
        saleOfData = !!cp.saleOfDataAllowed();
      }
      // Shopify API uses preferencesProcessingAllowed (not preferencesAllowed)
      if (typeof cp.preferencesProcessingAllowed === 'function') {
        preferences = !!cp.preferencesProcessingAllowed();
      } else if (typeof cp.preferencesAllowed === 'function') {
        preferences = !!cp.preferencesAllowed();
      }
    } catch (e) {
      // ignore
    }

    return {
      analytics: analytics,
      marketing: marketing,
      saleOfData: saleOfData,
      preferences: preferences,
    };
  }

  function pushConsentMode(allowed) {
    var adOk = allowed.marketing && allowed.saleOfData;
    gtag('consent', 'update', {
      analytics_storage: allowed.analytics ? 'granted' : 'denied',
      ad_storage: adOk ? 'granted' : 'denied',
      ad_user_data: adOk ? 'granted' : 'denied',
      ad_personalization: adOk ? 'granted' : 'denied',
    });

    window.dataLayer.push({
      event: 'krs_consent_update',
      krs_consent: {
        analytics: allowed.analytics,
        marketing: allowed.marketing,
        sale_of_data: allowed.saleOfData,
        preferences: allowed.preferences,
      },
    });

    try {
      document.documentElement.dispatchEvent(
        new CustomEvent('krs:consent', { detail: allowed })
      );
    } catch (e) {
      // ignore
    }
  }

  function injectScript(src, attrs) {
    var s = document.createElement('script');
    s.src = src;
    s.async = true;
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        s.setAttribute(k, attrs[k]);
      });
    }
    document.head.appendChild(s);
    return s;
  }

  function loadGtm(containerId) {
    if (GTM_LOADED || !containerId) return;
    GTM_LOADED = true;
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    injectScript('https://www.googletagmanager.com/gtm.js?id=' + encodeURIComponent(containerId));
  }

  function loadGtmTracking(url) {
    if (GTM_TRACKING_LOADED || !url) return;
    GTM_TRACKING_LOADED = true;
    var s = document.createElement('script');
    s.src = url;
    s.defer = true;
    document.head.appendChild(s);
  }

  function applyConsent(cp) {
    var cfg = getConfig();
    var allowed = readAllowed(cp);
    pushConsentMode(allowed);

    // Load GTM only when analytics or marketing processing is allowed
    if (cfg.gtmEnabled && cfg.gtmContainerId && (allowed.analytics || allowed.marketing)) {
      loadGtm(cfg.gtmContainerId);
      if (cfg.gtmTrackingUrl) loadGtmTracking(cfg.gtmTrackingUrl);
    }

    window.krsConsent = allowed;
  }

  function openCookiePreferences() {
    function tryOpen(attempts) {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        window.privacyBanner.showPreferences().catch(function () {});
        return;
      }
      if (attempts < 40) {
        setTimeout(function () {
          tryOpen(attempts + 1);
        }, 100);
        return;
      }
      // privacyBanner only exists when the cookie banner is active in
      // Settings → Customer privacy, so this store cannot open the prefs centre.
      console.warn('[krs-consent] cookie banner not enabled on this store; preferences unavailable');
    }
    tryOpen(0);
  }

  function isCookiePreferencesLink(el) {
    if (!el || el.tagName !== 'A') return false;
    var href = el.getAttribute('href') || '';
    return href === '#cookie-preferences' || /#cookie-preferences$/i.test(href);
  }

  function bindCookiePreferenceLinks() {
    document.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var link = t.closest('a[href="#cookie-preferences"], a[href$="#cookie-preferences"]');
        if (!link || !isCookiePreferencesLink(link)) return;
        e.preventDefault();
        openCookiePreferences();
      },
      true
    );

    if (location.hash === '#cookie-preferences') {
      openCookiePreferences();
    }
    window.addEventListener('hashchange', function () {
      if (location.hash === '#cookie-preferences') openCookiePreferences();
    });
  }

  function bindConsentListeners(cp) {
    if (listenersBound) return;
    listenersBound = true;

    document.addEventListener('visitorConsentCollected', function () {
      applyConsent(cp);
    });
    document.addEventListener('consentTrackingApiLoaded', function () {
      applyConsent(cp);
    });

    // Preference centre / banner clicks often update without a dedicated event on all themes
    document.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        if (
          t.closest('#shopify-pc__banner') ||
          t.closest('#shopify-pc__prefs') ||
          t.closest('[id^="shopify-pc"]')
        ) {
          setTimeout(function () {
            applyConsent(cp);
          }, 300);
          setTimeout(function () {
            applyConsent(cp);
          }, 1000);
        }
      },
      true
    );
  }

  function initWithPrivacy() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp) return;
    bindConsentListeners(cp);
    applyConsent(cp);
  }

  function loadPrivacyApi() {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      // Retry briefly — Shopify object may not be ready yet
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
          clearInterval(timer);
          loadPrivacyApi();
        } else if (tries > 40) {
          clearInterval(timer);
        }
      }, 100);
      return;
    }

    if (window.Shopify.customerPrivacy) {
      initWithPrivacy();
      return;
    }

    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (err) {
        console.warn('[krs-consent] consent-tracking-api failed', err);
        return;
      }
      initWithPrivacy();
    });
  }

  // Public helper for other snippets (e.g. Klaviyo)
  window.krsWhenMarketingAllowed = function (cb) {
    function check() {
      var allowed = window.krsConsent;
      if (allowed && allowed.marketing) {
        cb();
        return true;
      }
      return false;
    }
    if (check()) return;
    document.documentElement.addEventListener('krs:consent', function handler(e) {
      if (e.detail && e.detail.marketing) {
        document.documentElement.removeEventListener('krs:consent', handler);
        cb();
      }
    });
    // If region does not require consent, marketing may already be allowed after API load
    var wait = setInterval(function () {
      if (check()) clearInterval(wait);
    }, 250);
    setTimeout(function () {
      clearInterval(wait);
    }, 8000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindCookiePreferenceLinks();
      loadPrivacyApi();
    });
  } else {
    bindCookiePreferenceLinks();
    loadPrivacyApi();
  }
})();
